import React from 'react';
import { PaymentMethodForm } from './payment-method-form';
import { CCPCreditCardFormState } from '@atlassian/commerce-ui/credit-card-ccp';
import { AddPaymentMethodProps, PaymentMethodOperation } from './types';
import { useAddPaymentMethod } from './hooks/use-add-payment-method';
const AddPaymentMethod: React.FC<AddPaymentMethodProps> = ({
  txaId,
  onCancel,
  onUpdateDone,
  onUpdateSuccess,
  onUpdateFailure,
  overrideOnUpdateFailure,
  overrideOnUpdateSuccess,
  sidebarClassName,
  successMessage,
  failureMessage,
  showSubscriptionChargeNote,
  translateErrorMessage,
  header,
  subHeader,
  version,
  isPaypalSupportEnabled,
  paypalEmail,
  payPalEmails,
  shouldShowACHPaymentMethod,
}) => {
  const {
    isOperationInProgress,
    onAddPaymentMethod,
    onAddPaypalPaymentMethod,
    isPaypalOperationInProgress,
  } = useAddPaymentMethod({
    onUpdateDone,
    onUpdateFailure,
    onUpdateSuccess,
    successMessage,
    failureMessage,
    translateErrorMessage,
    overrideOnUpdateFailure,
    overrideOnUpdateSuccess,
  });
  return (
    <PaymentMethodForm
      txaId={txaId}
      operation={PaymentMethodOperation.ADD}
      onCancel={onCancel}
      isOperationInProgress={isOperationInProgress}
      onSubmit={onAddPaymentMethod}
      onPaypalSubmit={onAddPaypalPaymentMethod}
      isPaypalOperationInProgress={isPaypalOperationInProgress}
      sidebarClassName={sidebarClassName}
      showSubscriptionChargeNote={showSubscriptionChargeNote}
      header={header}
      subHeader={subHeader}
      version={version}
      isPaypalSelectionEnabled={isPaypalSupportEnabled}
      paypalEmail={paypalEmail}
      payPalEmails={payPalEmails}
      shouldShowACHPaymentMethod={shouldShowACHPaymentMethod}
      onUpdateDone={onUpdateDone}
      onUpdateFailure={onUpdateFailure}
      onUpdateSuccess={onUpdateSuccess}
    />
  );
};

export const AddPaymentMethodWrappedInStripeState: React.FC<AddPaymentMethodProps> = ({
  txaId,
  onCancel,
  ...otherProps
}) => {
  return (
    <CCPCreditCardFormState accountId={txaId}>
      <AddPaymentMethod txaId={txaId} onCancel={onCancel} {...otherProps} />
    </CCPCreditCardFormState>
  );
};
